// extracted by css-extract-rspack-plugin
export default {"form":"_15LHrmw1s_nxSiSuEkvCIE"};